
export const containerEntregaMultipla = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
}

export const sxOrigem = {
    border: '1px solid black',
    borderRadius: '10px'
}

export const styleImage = {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%'

}

export const sxImovelEntregaMultipla = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
}

export const styleIcons = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '10px'
}

export const styleAddRemove = {
    backgroundColor: 'white',
    borderRadius: '5px',
    padding: '1px'
}

export const styleDestinatario = {
    marginTop: '20px',
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    maxHeight: '500px',
    overflowY: 'auto'
}
